import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ColorSwatch = ({ name, token, hex, usage }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator?.clipboard?.writeText(hex);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="p-4 rounded-lg bg-card border border-border hover:border-primary/50 transition-colors duration-250">
      <div 
        className="w-full h-20 rounded-md mb-3 border border-border cursor-pointer hover:scale-105 transition-transform duration-250"
        style={{ backgroundColor: hex }}
        onClick={handleCopy}
        title="Click to copy hex value"
      />
      <div className="space-y-1">
        <h4 className="text-sm font-medium text-foreground">{name}</h4>
        <div className="flex items-center justify-between">
          <code className="text-xs text-primary">{hex}</code>
          <button 
            onClick={handleCopy}
            className="p-1 hover:bg-muted rounded transition-colors duration-250"
            title="Copy hex value"
          >
            <Icon 
              name={copied ? 'Check' : 'Copy'} 
              size={14} 
              color={copied ? 'var(--color-success)' : 'var(--color-muted-foreground)'} 
            />
          </button>
        </div>
        <p className="text-xs text-muted-foreground">{usage}</p>
        <code className="text-xs text-muted-foreground block mt-1">{token}</code>
      </div>
    </div>
  );
};

export default ColorSwatch;